// Chat UI Constants - DEV-2105

export const CSS_CLASSES = {
  CHAT_CONTAINER: 'chat-container',
  CHAT_SIDEBAR: 'chat-sidebar',
  SIDEBAR_HEADER: 'sidebar-header',
  MESSAGE: 'message',
  MESSAGE_USER: 'message-user',
  MESSAGE_ASSISTANT: 'message-assistant',
  MESSAGE_CONTENT: 'message-content',
  MESSAGE_BUBBLE: 'message-bubble',
  TYPING_BUBBLE: 'typing-bubble',
  TYPING_DOTS: 'typing-dots',
  TYPING_TEXT: 'typing-text',
  PROGRESS_CONTAINER: 'progress-container',
  PROGRESS_BAR: 'progress-bar',
  PROGRESS_FILL: 'progress-fill',
};